import React from 'react';
import PropTypes from 'prop-types';
import './Tip.css';

const Tip = ({ children = 'Tip Content', title = '', marginTop = '0px', references = '' }) => (
  <div className="tip-container" style={{ marginTop }}>
    {title && <div className="tip-title">{title}</div>}
    <div className="tip-content" dangerouslySetInnerHTML={{__html:children}} />
    <div className="tip-reference">
      <p>{references ? "REFERENCES:" : ""}</p>
        {Array.isArray(references) ?
        <ul>
          {references.map((ref, index) => {
            return <li key={index}>{ref}</li>
          })}
        </ul>
             :
          <p>{references ? references : ""}</p>}
    </div>
  </div>
);

Tip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  marginTop: PropTypes.string
};

export default Tip;
